// @flow
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

// Components
import ContactInfo from './ContactInfo';

// Actions
import {
  setFirstName,
  setLastName,
  setEmail,
  setPhoneNumber,
  setObfuscatedBy,
  setLicenseNumber,
  sendCustomerInfoFormStart
} from 'store/reducers/appointment/actions';
import { gtmUserEvent } from 'store/reducers/gtm/actions';
import { resetObfuscatedContactInfo } from 'store/reducers/appointment/contactInfo/actions';
import { setContactInfoFormValid } from 'store/reducers/userInteractions/actions';
// Selectors
import {
  getContactInfo,
  getVehicle,
  getAttendanceStatus,
  isDmsAppt
} from 'store/reducers/appointment/selectors';
import {
  getIsObfuscated,
  getObfuscatedBy,
  getMobilePhone
} from 'store/reducers/appointment/contactInfo/selectors';
import { getDealerCountryCode } from 'store/reducers/dealerSettings/selectors';
import {
  getAppFlow,
  isModifyEnabledFindMe,
  isContactInfoFormValid,
  getSavedMobile
} from 'store/reducers/userInteractions/selectors';

function mapStateToProps(state) {
  const contactInfo = getContactInfo(state);
  return {
    contactInfo,
    initialValues: contactInfo,
    dealerCountryCode: getDealerCountryCode(state),
    appFlow: getAppFlow(state),
    isObfuscated: getIsObfuscated(state),
    obfuscatedBy: getObfuscatedBy(state),
    isModifyEnabledFindMe: isModifyEnabledFindMe(state),
    vehicle: getVehicle(state),
    appointmentStatus: getAttendanceStatus(state),
    mobilePhone: getMobilePhone(state) || getSavedMobile(state),
    isContactInfoFormValid: isContactInfoFormValid(state),
    isDmsAppt: isDmsAppt(state)
  };
}

const mapDispatchToProps = {
  setFirstName,
  setLastName,
  setEmail,
  setPhoneNumber,
  setLicenseNumber,
  gtmUserEvent,
  setObfuscatedBy,
  resetObfuscatedContactInfo,
  setContactInfoFormValid,
  sendCustomerInfoFormStart
};

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ContactInfo);



// WEBPACK FOOTER //
// ./src/components/molecules/ContactInfo/ContactInfoContainer.js